export const DATA_MANAGER_GRID_SELECTION_COLUMN_WIDTH = 44;
export const DATA_MANAGER_GRID_SELECTION_COLUMN_MIN_WIDTH = 32;
export const DATA_MANAGER_GRID_SELECTION_COLUMN_KEY = "__selection__";
export const DATA_MANAGER_GRID_ACTIONS_COLUMN_WIDTH = 112;
export const DATA_MANAGER_GRID_COMPARTMENT_POSITION_COLUMN_WIDTH = 56;

export const DATA_MANAGER_RESIZABLE_SELECTION_COLUMN = {
  key: DATA_MANAGER_GRID_SELECTION_COLUMN_KEY,
  defaultWidth: DATA_MANAGER_GRID_SELECTION_COLUMN_WIDTH,
  minWidth: DATA_MANAGER_GRID_SELECTION_COLUMN_MIN_WIDTH,
};

export function resolveDataManagerFixedColumnWidth(column, columnWidths = {}, savedWidths = {}) {
  const columnKey = column?.key;
  const defaultWidth = Math.max(0, Math.round(Number(column?.defaultWidth) || 0));

  if (!columnKey) {
    return defaultWidth;
  }

  if (typeof columnWidths?.[columnKey] === "number" && columnWidths[columnKey] > 0) {
    return columnWidths[columnKey];
  }

  if (typeof savedWidths?.[columnKey] === "number" && savedWidths[columnKey] > 0) {
    return savedWidths[columnKey];
  }

  return defaultWidth;
}

export function getDataManagerGridTableWidth(resolvedColumns = [], fixedColumnWidths = []) {
  const fixedTotal = fixedColumnWidths.reduce((sum, width) => sum + width, 0);
  const columnsTotal = resolvedColumns.reduce(
    (totalWidth, column) => totalWidth + Math.max(
      0,
      Math.round(Number(column.width) || Number(column.defaultWidth) || 0),
    ),
    0,
  );

  return fixedTotal + columnsTotal;
}

export function resolveDataManagerGridColumnWidth(column) {
  if (typeof column?.width === "number" && column.width > 0) {
    return column.width;
  }

  if (typeof column?.defaultWidth === "number" && column.defaultWidth > 0) {
    return column.defaultWidth;
  }

  return 0;
}

export function buildDataManagerGridTableStyle(tableWidth) {
  const resolvedWidth = Math.max(0, Math.round(Number(tableWidth) || 0));

  return {
    minWidth: `${resolvedWidth}px`,
    tableLayout: "fixed",
    width: `${resolvedWidth}px`,
  };
}
